import { Button, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import LeftArrowIcon from '@/assets/icons/ic-arrow-left.svg';

import { CoreHero, CoreHeroBody, CoreHeroTitle } from '@/components/ui/shared/heroes/CoreHero/CoreHero';

export const LibrariansResourceHeader: FC = () => {
  const { t } = useTranslation();

  return (
    <CoreHero>
      <CoreHeroBody>
        <NextLink href="/librarians" passHref legacyBehavior>
          <Button
            leftIcon={<LeftArrowIcon />}
            colorScheme="white"
            variant="link"
            pt={4}
            display={{ base: 'none', lg: 'flex' }}
          >
            {t('librariansResource.header.button')}
          </Button>
        </NextLink>
        <CoreHeroTitle
          fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
          lineHeight={{ base: '48px', md: '64px', lg: '60px' }}
          textAlign="center"
          textTransform="capitalize"
          p={{ base: '75px 0 42px', lg: '34px 0' }}
        >
          {t('librariansResource.header.title')}
        </CoreHeroTitle>
        <Text
          fontSize={{ base: 'md', md: 'xl', lg: 'xl' }}
          lineHeight={{ base: 5, md: 6, lg: 7 }}
          fontFamily="body"
          color="gray.100"
          textAlign="center"
          pb={24}
          mx="auto"
          maxW="794px"
        >
          {t('librariansResource.header.description')}
        </Text>
      </CoreHeroBody>
    </CoreHero>
  );
};
